import React, { useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import JobOrders from "./Screens/jobOrders";
import FindTalent from "./Screens/findTalent";
import Forgetpassword from "./Screens/forgetpassword";
import "react-toastify/dist/ReactToastify.css";
import Createpassword from "./Screens/createpassword";
import Changepassword from "./Screens/changepassword";
import JobDetails from "./Screens/jobDetails";
import SearchCandidate from "./Screens/searchCandidate";
import Login from "./Screens/login";
import Cookies from "js-cookie";
import Createjob from "./Screens/Createjob";
import useAxiosInterceptor from "./interceptors/axios";
import ManageCandidate from "./Screens/ManageCandidate";
import OpenDrawer from "./components/OpenDrawer";
import CompanyLists from "./Screens/companyLists";
import AddCompany from "./Screens/addCompany";
import CompanyDetails from "./Screens/companyDetails";
import AddBranch from "./components/addBranch";
import BranchDetails from "./Screens/branchDetails";
import UsersLists from "./Screens/usersLists";
import UserDetails from "./Screens/userDetails";
import UserAdditon from "./Screens/userAdditon";
import UserDetailsPreview from "./Screens/userDetailsPreview";
import Customdashboard from "./Screens/Dashboard/dashboard";
import Header from "./components/header";
import {
  Box,
  Tooltip,
  List,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Skeleton,
  Snackbar,
  Alert,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { useDispatch, useSelector } from "react-redux";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import MyDashboard from "./Screens/myDashboard/MyDashboard";
import RichTextEditor from "./Screens/Blogs/RichTextEditor";
import BlogList from "./Screens/Blogs/BlogList";
import BlogDisplay from "./Screens/Blogs/BlogDisplay";
import AddedBulkCandidates from "./components/addedBulkCandidates";

import axios from "axios";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import CancelPresentationOutlinedIcon from "@mui/icons-material/CancelPresentationOutlined";

const {
  REACT_APP_EMPLOYER_LOGO,
  REACT_APP_ZED_LOGO,
} = process.env;

const drawerWidth = 224;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(12.75)} + 1px)`,
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const mailtoken = window.location.pathname?.split("/")[2]?.split("=")[1];
  const containerRef = React.useRef(null);
  const location = useLocation();
  const navigation = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams({});
  const roles = useSelector((state) => state.user.role);
  const managePermissions = useSelector((state) => state?.user.permissions);
  const token = useSelector((state) => state.user.token);
  const createPage = (label, iconPath, path, activePaths) => {
    const isActive = activePaths.includes(location.pathname.split("/")[1]);

    return {
      label,
      icon: (
        <img
          src={iconPath}
          className={`menu-icon ${isActive ? "active" : ""}`}
          style={{ width: 20, height: 20 }}
        />
      ),
      path,
      active: isActive,
    };
  };

  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const [processedFiles, setProcessedFiles] = useState([]);
  const [uploadPanelOpen, setUploadPanelOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  useEffect(() => {
    const storedJobId = localStorage.getItem("bulkUploadJobId");
    if (storedJobId) {
      setUploadPanelOpen(true);
      setIsProcessing(true);

      const savedFiles = JSON.parse(
        localStorage.getItem("bulkUploadFiles") || "[]",
      );
      if (savedFiles.length) {
        setUploadingFiles(
          savedFiles.map((name) => ({ file: { name }, selected: true })),
        );
      }
      pollStatus(storedJobId);
    }
  }, []);

  const employerPages = [
    createPage("Dashboard", "/assets/dashboard.svg", "/mydashboard", [
      "mydashboard",
      "dashboard",
    ]),
    createPage("Jobs", "/assets/jobs.svg", "/jobOrders?page=1", [
      "jobOrders",
      "Postjob",
    ]),
    createPage("Companies", "/assets/company.svg", "/Company?page=1", [
      "Company",
      "CompanyDetails",
      "addCompany",
    ]),
    createPage("Users", "/assets/users.svg", "/Users?page=1", [
      "Users",
      "UsersDetails",
      "addUser",
    ]),
    createPage("Find Talent", "/assets/find_talent.svg", "/Find-talents", [
      "Find-talents",
      "searchCandidate",
    ]),
    createPage(
      "Manage Candidates",
      "/assets/manage_candidate.svg",
      "/Manage-Candidates?page=1",
      ["Manage-Candidates", "added-candidates"],
    ),
  ];
  const recruiterPages = [
    createPage("Dashboard", "/assets/dashboard.svg", "/mydashboard", [
      "mydashboard",
      "dashboard",
    ]),
    createPage("Jobs", "/assets/jobs.svg", "/jobOrders?page=1", [
      "jobOrders",
      "Postjob",
    ]),
    createPage("Companies", "/assets/company.svg", "/Company?page=1", [
      "Company",
      "CompanyDetails",
      "addCompany",
    ]),

    createPage("Find Talent", "/assets/find_talent.svg", "/Find-talents", [
      "Find-talents",
      "searchCandidate",
    ]),
    createPage(
      "Manage Candidates",
      "/assets/manage_candidate.svg",
      "/Manage-Candidates?page=1",
      ["Manage-Candidates"],
    ),
  ];
  const atsPages = [
    createPage("Dashboard", "/assets/dashboard.svg", "/mydashboard", [
      "mydashboard",
      "dashboard",
    ]),
    createPage("Jobs", "/assets/jobs.svg", "/jobOrders?page=1", [
      "jobOrders",
      "Postjob",
    ]),
    createPage(
      "Manage Candidates",
      "/assets/manage_candidate.svg",
      "/Manage-Candidates?page=1",
      ["Manage-Candidates"],
    ),
  ];

  const onlyBlogPages = [
    createPage("Blogs", <RssFeedIcon />, "/blogs", ["blogs", "blog"]),
  ];
  const roleBasedpermission = () => {
    if (roles === "RECRUITER") {
      return recruiterPages;
    } else if (roles == "ATS") {
      return atsPages;
    } else if (roles === "SEO") {
      return onlyBlogPages;
    } else {
      return employerPages;
    }
  };

  const handleNavigation = (path) => {
    navigation(path);
    sessionStorage.clear();
  };
  const handleDrawerClose = () => {
    setOpen((prev) => !prev);
  };

  const excludedPaths = [
    "/login",
    "/forgetpassword",
    `/createpassword/_secure_ARJ_=${mailtoken}`,
  ];

  const shouldRenderHeader = !excludedPaths.includes(location.pathname);
  const dispatch = useDispatch();

  useAxiosInterceptor();

  useEffect(() => {
    setIsLoggedIn(
      !!(Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref")),
    );
  }, []);

  const isAuthenticated = !!(
    Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref")
  );

  const handleOpenDetails = () => {
    navigation("/added-candidates");
  };

  const pollStatus = (jobId) => {
    localStorage.setItem("bulkUploadJobId", jobId);
    setIsProcessing(true);
    const intervalId = setInterval(async () => {
      try {
        const { data } = await axios.get(`/status/${jobId}`, {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        });

        const { total, processed } = data.message;
        setUploadProgress(processed);
        setProcessedFiles(data.message.processedFiles);
        console.log(`Progress: ${processed}/${total}`);

        if (parseInt(total) === parseInt(processed)) {
          clearInterval(intervalId);
          setIsProcessing(false);
          setTimeout(() => {
            const currentUrl = window.location.href;
            if (currentUrl.includes("/Manage-Candidates")) {
              window.dispatchEvent(new CustomEvent("bulkUploadComplete"));
            }
          }, 1500);
          console.log("Processing complete!");
        }
      } catch (err) {
        console.error("Error polling status:", err);
        clearInterval(intervalId);
        setIsProcessing(false);
      }
    }, 10000);
  };

  const handleSnackbarClose = () => {
    setSnackbar({
      open: false,
      message: "",
      severity: "error",
    });
  };
  console.log("EMPLOYER_LOGO", REACT_APP_EMPLOYER_LOGO);
console.log("ZED_LOGO", REACT_APP_ZED_LOGO);

  return (
    <Box sx={{ display: "flex", width: "100vw" }}>
      {shouldRenderHeader && (
        <Drawer
          variant="permanent"
          open={open}
          className="drawer"
          sx={{
            "& .MuiDrawer-paper": {
              border: "none",
            },
          }}
        >
          <DrawerHeader
            sx={{
              py: 3,
              height: "fit-content",
              minHeight: "0 !important",
              paddingBottom: "0px",
              px: "16px",
            }}
          >
            <IconButton
              sx={{
                margin: "0 auto",
                p: 0,
                backgroundColor: "transparent !important",
                "&:hover": {
                  backgroundColor: "transparent !important",
                },
              }}
              disableRipple
              onClick={handleDrawerClose}
            >
              <div className={`logo ${open ? "" : "hidden"}`}>
                <img
                  src={REACT_APP_EMPLOYER_LOGO}
                  style={{ height: "42px" }}
                  alt="Logo"
                />

              </div>
              <div className={`logo ${open ? "hidden" : ""}`}>
                <img
                  src={REACT_APP_ZED_LOGO}
                  style={{ height: "23px" }}
                  alt="Logo"
                />
              </div>
            </IconButton>
          </DrawerHeader>
          <List sx={{ px: "16px", pt: 8 }}>
            {roleBasedpermission().map((menuItem) => (
              <ListItem
                key={menuItem.label}
                disablePadding
                sx={{ display: "block", mb: "8px" }}
              >
                {open ? (
                  <ListItemButton
                    sx={{
                      px: "14px",
                      py: "18px",
                      borderRadius: "8px",
                      fontWeight: 500,
                      justifyContent: open ? "initial" : "center",
                      display: "flex",
                      gap: "10px",
                      color: `${menuItem.active ? "#fff" : "#737791"}`,
                    }}
                    onClick={() => handleNavigation(menuItem.path)}
                    className={`${menuItem.active ? "activeSidebarMenu" : ""}`}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        // mr: open ? 1.5 : "auto",
                        justifyContent: "center",
                        color: `${menuItem.active ? "#fff" : "#737791"}`,
                      }}
                    >
                      {menuItem.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={menuItem.label}
                      sx={{
                        m: 0,
                        opacity: open ? 1 : 0,
                        display: open ? "block" : "none",
                      }}
                      primaryTypographyProps={{
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    />
                  </ListItemButton>
                ) : (
                  <Tooltip title={menuItem.label} placement="top">
                    <ListItemButton
                      sx={{
                        px: 2.5,
                        py: 2,
                        borderRadius: "8px",
                        fontWeight: 500,
                        justifyContent: open ? "initial" : "center",
                        color: `${menuItem.active ? "#fff" : "#737791"}`,
                      }}
                      onClick={() => handleNavigation(menuItem.path)}
                      className={`${
                        menuItem.active ? "activeSidebarMenu" : ""
                      }`}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          // mr: open ? 1.5 : "auto",
                          justifyContent: "center",
                          color: `${menuItem.active ? "#fff" : "#737791"}`,
                        }}
                      >
                        {menuItem.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={menuItem.label}
                        sx={{
                          m: 0,
                          opacity: open ? 1 : 0,
                          display: open ? "block" : "none",
                        }}
                      />
                    </ListItemButton>
                  </Tooltip>
                )}
              </ListItem>
            ))}
          </List>
        </Drawer>
      )}
      <Box sx={{ width: "100%", height: "100vh", overflow: "hidden" }}>
        {shouldRenderHeader && <Header />}
        <div
          ref={containerRef}
          style={{
            // ✅ FIX: Use full 100vh on login/auth pages where header is hidden
            height: shouldRenderHeader ? `calc(100vh - 66px)` : "100vh",
            width: "100%",
            overflowY: "auto",
            background: shouldRenderHeader ? "#E3F2FD" : "#FFF",
            padding: "16px",
            borderRadius: "24px 0 0 0",
          }}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route
              path="/login"
              element={
                isAuthenticated ? (
                  roles === "SEO" ? (
                    <Navigate to="/blogs" />
                  ) : (
                    <Navigate to="/mydashboard" />
                  )
                ) : (
                  <Login setIsLoggedIn={setIsLoggedIn} />
                )
              }
            />

            <Route
              path="/forgetpassword"
              element={<Forgetpassword setIsLoggedIn={setIsLoggedIn} />}
            />
            <Route
              path={`/createpassword/_secure_ARJ_=${mailtoken}`}
              element={<Createpassword />}
            />
            <Route element={<PrivateRoutes setSnackbar={setSnackbar} />}>
              {roles === "SEO" && (
                <>
                  <Route path="/blogs" element={<BlogList />} />
                  <Route path="/blog/create" element={<RichTextEditor />} />
                  <Route path="/blog/details/:id" element={<BlogDisplay />} />
                  <Route path="/blog/:id/edit" element={<RichTextEditor />} />
                </>
              )}

              {roles !== "SEO" && (
                <>
                  <Route path="/changepassword" element={<Changepassword />} />
                  <Route path="/jobOrders" element={<JobOrders />} />
                  <Route path="/Postjob" element={<Createjob />} />
                  {roles != "ATS" && (
                    <>
                      <Route path="/Find-talents" element={<FindTalent />} />
                      <Route path="/Company" element={<CompanyLists />} />
                      <Route path="/addCompany" element={<AddCompany />} />
                      <Route
                        path="/CompanyDetails/:id/addBranch"
                        element={<AddBranch />}
                      />
                      <Route
                        path="/CompanyDetails/:id"
                        element={<CompanyDetails />}
                      />
                      <Route
                        path="/CompanyDetails/:id/BranchDetails/:branchId"
                        element={<BranchDetails />}
                      />
                    </>
                  )}
                  <Route
                    path="/Manage-Candidates"
                    element={
                      <ManageCandidate
                        pollStatus={pollStatus}
                        setUploadProgress={setUploadProgress}
                        setUploadingFiles={setUploadingFiles}
                        setUploadPanelOpen={setUploadPanelOpen}
                        setProcessedFiles={setProcessedFiles}
                        isProcessing={isProcessing}
                        setIsProcessing={setIsProcessing}
                      />
                    }
                  />
                  <Route
                    path="/Manage-Candidates/:id"
                    element={<OpenDrawer />}
                  />
                  <Route path="/jobOrders/:id" element={<JobDetails />} />
                  <Route
                    path="/searchCandidate"
                    element={<SearchCandidate />}
                  />
                  <Route
                    path="/added-candidates"
                    element={
                      <AddedBulkCandidates
                        processedFiles={processedFiles}
                        isProcessing={isProcessing}
                      />
                    }
                  />
                </>
              )}
              {roles != "ATS" && roles !== "RECRUITER" && roles !== "SEO" && (
                <>
                  <Route path="/Users" element={<UsersLists />} />
                  <Route path="/UsersDetails/:id" element={<UserDetails />} />
                  <Route path="/addUser" element={<UserAdditon />} />
                </>
              )}
              {roles !== "SEO" && (
                <>
                  <Route path="/dashboard" element={<Customdashboard />} />
                  <Route path="/mydashboard" element={<MyDashboard />} />
                </>
              )}
              {roles === "SEO" ? (
                <Route path="*" element={<Navigate to="/blogs" />} />
              ) : (
                <Route path="*" element={<Navigate to="/mydashboard" />} />
              )}
            </Route>
          </Routes>
        </div>
      </Box>

      {uploadPanelOpen && (
        <Draggable handle=".upload-drag-handle" bounds="body">
          <Box
            sx={{
              position: "fixed",
              bottom: 20,
              right: 20,
              width: 480,
              zIndex: 1300,
              bgcolor: "white",
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            <Box
              className="upload-drag-handle"
              sx={{
                cursor: "move",
                p: "10px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography fontWeight="500">Adding Bulk Candidates</Typography>
              {uploadProgress >= uploadingFiles.length ? (
                <IconButton
                  onClick={() => {
                    setUploadPanelOpen(false);
                    localStorage.removeItem("bulkUploadJobId");
                  }}
                >
                  <CloseIcon />
                </IconButton>
              ) : (
                <OpenInNewOutlinedIcon
                  sx={{
                    border: "1px solid #D9EAFB",
                    borderRadius: "8px",
                    padding: "6px",
                    fontSize: "28px",
                    color: "#1A1A1A",
                    cursor: "pointer",
                  }}
                  onClick={handleOpenDetails}
                />
              )}
            </Box>
            <Divider />

            {uploadProgress < uploadingFiles.length ? (
              <>
                <Box p={"20px 20px 0px 20px"}>
                  {processedFiles.slice(0, 2).map((file, index) => (
                    <Box key={index} mb={2}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        gap={2}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={2}
                          flex={1}
                        >
                          {file.status === "successful" ? (
                            <TaskOutlinedIcon
                              sx={{
                                color: "#4CAF50",
                                border: "1px solid #3F95EA33",
                                borderRadius: "8px",
                                padding: "8px",
                                fontSize: "38px",
                              }}
                            />
                          ) : (
                            <CancelPresentationOutlinedIcon
                              sx={{
                                color: "#E25C72",
                                border: "1px solid #3F95EA33",
                                borderRadius: "8px",
                                padding: "8px",
                                fontSize: "38px",
                              }}
                            />
                          )}

                          <Box>
                            <Typography
                              variant="body1"
                              color="text.primary"
                              fontWeight="bold"
                              fontSize={18}
                              noWrap
                              sx={{ maxWidth: 220 }}
                            >
                              {file.fileName}
                            </Typography>
                            <Typography
                              color={
                                file.status === "successful"
                                  ? "text.secondary"
                                  : "error"
                              }
                              size={14}
                            >
                              {file.fileSize < 1024 * 1024
                                ? `${(file.fileSize / 1024).toFixed(2)} KB`
                                : `${(file.fileSize / (1024 * 1024)).toFixed(
                                    2,
                                  )} MB`}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
                <Divider />
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  p={2.5}
                >
                  <Skeleton variant="circular" width={40} height={40} />
                  <Box sx={{ flex: 1, ml: 2 }}>
                    <Skeleton variant="text" width="60%" height={20} />
                    <Skeleton variant="text" width="40%" height={20} />
                  </Box>
                </Box>
                <Divider />
                <Box display="flex" flexDirection="column" p={"10px 20px"}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        flexGrow: 1,
                        height: 5,
                        backgroundColor: "#e0e0e0",
                        borderRadius: 5,
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        sx={{
                          width: `${
                            (uploadProgress / uploadingFiles.length) * 100
                          }%`,
                          backgroundColor: "#3f95ea",
                          height: "100%",
                        }}
                      />
                    </Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      minWidth={30}
                    >
                      {Math.round(
                        (uploadProgress / uploadingFiles.length) * 100,
                      )}
                      %
                    </Typography>
                  </Box>
                  <Typography fontSize={14}>
                    {uploadProgress}/{uploadingFiles.length} Candidates
                    Processed
                  </Typography>
                </Box>
              </>
            ) : (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                p={2}
              >
                <Box display="flex" alignItems="center" gap={2}>
                  <CheckCircleOutlineOutlinedIcon
                    sx={{ color: "#4CAF50", fontSize: 50 }}
                  />
                  <Box>
                    <Typography sx={{ fontSize: "18px", fontWeight: "500" }}>
                      Candidates Processed Successfully!
                    </Typography>
                    <Typography fontSize={14} color="text.secondary">
                      {uploadingFiles.length}/{uploadingFiles.length}
                    </Typography>
                  </Box>
                </Box>
                <IconButton>
                  <OpenInNewOutlinedIcon
                    sx={{
                      border: "1px solid #D9EAFB",
                      borderRadius: "8px",
                      padding: "6px",
                      fontSize: "32px",
                      color: "#1A1A1A",
                    }}
                    onClick={handleOpenDetails}
                  />
                </IconButton>
              </Box>
            )}
          </Box>
        </Draggable>
      )}

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

function PrivateRoutes({ setSnackbar }) {
  const isAuthenticated = !!(
    Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref")
  );
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      setSnackbar({
        open: true,
        message: "Session expired. Please login again",
        severity: "error",
      });
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}

function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

export default AppWrapper;
